import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'redux-first-router-link'; 
import Recirculation from '../common/Recirculation';
import { getRecirculationData } from '../../utils';
import './404.scss';

class NotFoundView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      articles: [],
    };
  }

  componentDidMount() {
    getRecirculationData()
      .then((articles) => {
        if (articles.length > 0) {
          this.setState({ 
            articles 
          });
        }
      });
  }

  render() {
    const { isMobile } = this.props;
    const { articles } = this.state;
    const msg = "Well, this is unfortunate";

    return (
      <div>
        <div className="not-found">
          <div className="not-found-hdr-container">
            <h2>{msg}</h2>
          </div>
          <p className="not-found-copy">
            It would appear we have misplaced what you were looking for. <NavLink to='/honorees'>Lets try something else.</NavLink>
          </p>
        </div>
        <Recirculation articles={articles} isMobile={isMobile} />
      </div>
    );
  }
}

const mapState = ({ isMobile }) => {
  return {
    isMobile
  }
};

const NotFound = connect(mapState)(NotFoundView);

export default NotFound;

